<template>
  <div class="textarea_box" :class="{has_btn: clearable}">
    <div class="textarea">
      <textarea
        ref="textAreaRef"
        :class="['inp', formClass, { inp_error: error, w100p: justify }]"
        v-bind="attrs"
        v-on="listeners"
      />
      <button
        type="button"
        class="btn_reset"
        v-if="clearable && hasValue"
        @click="clear"
      >
        <span class="txt_hidden">값 지우기</span>
      </button>
    </div>
    <div class="inp_info" v-if="maxlength || errorMessage">
      <span v-if="errorMessage" class="error_text" >{{ errorMessage }}</span>
      <span v-if="maxlength" class="text">
        <strong :style="{color:lengthColor}">{{ length }}</strong>
        {{ maxlength }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "update",
  },

  props: {
    error: [Boolean, String],
    clearable: Boolean,
    value: String,
    maxlength: {
      type: Number,
      default: null,
    },
    justify: Boolean,
    clearable: {
      type: Boolean,
      default: false,
    },
    formClass: String,
    lengthColor: {
      type: String,
      default: null
    },
  },

  data() {
    return {
      hasFocus: false,
      localValue: this.value,
    };
  },

  computed: {
    attrs() {
      return {
        ...this.$attrs,
        value: this.localValue,
        maxlength: this.maxlength,
      };
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        focus: this.onFocus,
        blur: this.onBlur,
      };
    },
    input() {
      return this.$refs.textAreaRef;
    },
    hasValue() {
      return !!this.localValue;
    },
    errorMessage() {
      return typeof this.error === "string" ? this.error : "";
    },
    length() {
      return this.localValue?.length || 0;
    },
  },

  methods: {
    clear() {
      this.input.focus();
      this.$nextTick(() => {
        this.input.value = "";
        this.localValue = this.input.value;
      });
    },

    onInput(e) {
      this.localValue = e.target.value;
      this.$emit("input", e);
    },

    onFocus(e) {
      this.hasFocus = true;
      this.$emit("focus", e);
    },

    onBlur(e) {
      this.hasFocus = false;
      this.$emit("blur", e);
    },

    focus() {
      this.$el.querySelectorAll('input,select,textarea')[0]?.focus()
    },
  },

  watch: {
    value() {
      this.localValue = this.value;
    },
    localValue() {
      this.$emit("update", this.localValue);
    },
  },
};
</script>

<style></style>
